<template>
    <div>
        <vue-anka-cropper v-if="imageType !== 'cover' && imageType !== 'quoteAndPricingLogo'"
            :options="{
               aspectRatio: 1800/200,
               closeOnSave: true,
               croppedHeight: 200,
               croppedWidth: 1800,
               dropareaMessage: 'Upload file or drag and drop',
               frameLineDash: [0,0],
               frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
               handleFillColor: 'rgba(255, 255, 255, 1.0)',
               handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
               handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
               handleSize: 13,
               handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
               overlayFill: 'rgba(0, 0, 0, 0.1)',
               previewOnDrag: true,
               selectButtonLabel: 'Select Files',
               showPreview: true,
               previewQuality: 1,
               resultQuality: 1,
               skin: 'light',
               uploadData: {
                type: imageType,
                proposalTemplateId: proposalTemplateId
                },
               uploadTo:uploadUrl
               }"
            @cropper-saved="savedAction(cropData)"
            @cropper-uploaded="afterSavedAction(cropData)"
        ></vue-anka-cropper>
        <vue-anka-cropper v-else-if="imageType == 'quoteAndPricingLogo'"
            :options="{
                   aspectRatio: 640/534,
                   closeOnSave: true,
                   croppedHeight: 534,
                   croppedWidth: 640,
                   dropareaMessage: 'Upload file or drag and drop',
                   frameLineDash: [0,0],
                   frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
                   handleFillColor: 'rgba(255, 255, 255, 1.0)',
                   handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
                   handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
                   handleSize: 13,
                   handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
                   overlayFill: 'rgba(0, 0, 0, 0.1)',
                   previewOnDrag: true,
                   selectButtonLabel: 'Select Files',
                   showPreview: true,
                   previewQuality: 1,
                   resultQuality: 1,
                   skin: 'light',
                   uploadData: {
                    type: imageType,
                    proposalTemplateId: proposalTemplateId
                    },
                   uploadTo:uploadUrl
            }"
            @cropper-saved="savedAction(cropData)"
            @cropper-uploaded="afterSavedAction(cropData)"
        ></vue-anka-cropper>
        <vue-anka-cropper v-else
            :options="{
               aspectRatio: false,
               closeOnSave: true,
               croppedHeight: false,
               croppedWidth: false,
               dropareaMessage: 'Upload file or drag and drop',
               frameLineDash: [0,0],
               frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
               handleFillColor: 'rgba(255, 255, 255, 1.0)',
               handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
               handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
               handleSize: 13,
               handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
               overlayFill: 'rgba(0, 0, 0, 0.1)',
               previewOnDrag: true,
               selectButtonLabel: 'Select Files',
               showPreview: true,
               previewQuality: 1,
               resultQuality: 1,
               skin: 'light',
               uploadData: {
                type: imageType,
                proposalTemplateId: proposalTemplateId
                },
               uploadTo:uploadUrl
               }"
              @cropper-saved="savedAction(cropData)"
              @cropper-uploaded="afterSavedAction(cropData)"
        ></vue-anka-cropper>
    </div>
</template>

<script>
import vueAnkaCropper from 'vue-anka-cropper';
export default {
    name: 'image-cropper',
    props: ['url', 'imageType', 'proposalTemplateId'],
    components: {vueAnkaCropper},
    data() {
        return {
            cropData:null,
            uploadUrl: this.url
        }
    },
    mounted() {

    },
    created() {

    },
    methods: {
        savedAction(cropData){
            console.log('here', cropData);
        },
        afterSavedAction(cropData){
            if(this.imageType == 'quoteAndPricingLogo'){
                this.$parent.fetchSettings();
            }else{
                $('#uploadAndCropImage').modal('hide');
                this.$parent.fetchPGTemplateInfo();
            }
        }
    }
}
</script>
<style>

.ankaCropper {
    background: #e3eaf0;
    border-radius: 3px;
    -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .1), 3px 3px 5px rgba(0, 0, 0, .3);
    box-shadow: 0 0 20px rgba(0, 0, 0, .1), 3px 3px 5px rgba(0, 0, 0, .3);
    position: relative;
    overflow: hidden;
    font-family: Avenir, Helvetica, Helvetica Neue, Arial, sans-serif;
    font-size: 16px
}

.ankaCropper a {
    text-decoration: none
}

.ankaCropper__droparea {
    text-align: center;
    margin: 2em;
    padding: 2em
}

.ankaCropper__selectButton {
    border: none;
    padding: 10px 20px;
    margin: 10px;
    border-radius: 3px;
    cursor: pointer;
    -webkit-transition: all .3s;
    transition: all .3s
}

.ankaCropper__navigation {
    padding: 12px;
    border-radius: 3px;
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, .15);
    box-shadow: 0 2px 3px rgba(0, 0, 0, .15)
}

.ankaCropper__navButton {
    padding: 8px;
    width: 16px;
    margin-right: 10px
}

.ankaCropper__navButton {
    border-radius: 3px;
    display: inline-block;
    height: 40px;
    -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .15), 1px 1px 2px rgba(0, 0, 0, .25);
    box-shadow: 0 0 4px rgba(0, 0, 0, .15), 1px 1px 2px rgba(0, 0, 0, .25);
    overflow: hidden;
    width: 34px;
    background: white;
    padding: 8px 10px;
}



.ankaCropper__saveButton {
    border-radius: 3px;
    display: inline-block;
    height: 40px;
    -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .15), 1px 1px 2px rgba(0, 0, 0, .25);
    box-shadow: 0 0 4px rgba(0, 0, 0, .15), 1px 1px 2px rgba(0, 0, 0, .25)
}
.ankaCropper__saveButton {
    float: right;
    padding: 8px 20px;
    font-size: 14px
}

.ankaCropper__saveButton svg {
    vertical-align: bottom
}

.ankaCropper__mainArea {
    margin: 12px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    text-align: center
}

.ankaCropper__previewArea {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

.ankaCropper.light {
    background: #e3eaf0;
    color: #0f1114
}

.ankaCropper.light .ankaCropper__droparea {
    border: 2px dashed #367bb7
}

.ankaCropper.light .ankaCropper__saveButton,
.ankaCropper.light .ankaCropper__selectButton {
    background: #1c6bd6;
    color: #fff
}

.ankaCropper.light .ankaCropper__saveButton:hover,
.ankaCropper.light .ankaCropper__selectButton:hover {
    background: #1b5bb2
}

.ankaCropper.light .ankaCropper__navigation {
    background: #e8f2fa
}

.ankaCropper.light .ankaCropper__navButton svg {
    stroke: #0f1114
}

.ankaCropper.light .ankaCropper__navButton:hover {
    background: #fff
}

.ankaCropper.dark {
    background: #0f1114;
    color: #eee
}

.ankaCropper.dark .ankaCropper__droparea {
    border: 2px dashed #3e424b
}

.ankaCropper.dark .ankaCropper__saveButton,
.ankaCropper.dark .ankaCropper__selectButton {
    background: #334f90;
    color: #fff
}

.ankaCropper.dark .ankaCropper__saveButton:hover,
.ankaCropper.dark .ankaCropper__selectButton:hover {
    background: #335dbe
}

.ankaCropper.dark .ankaCropper__navigation {
    background: #1d2227
}

.ankaCropper.dark .ankaCropper__navButton {
    background: #272c31
}

.ankaCropper.dark .ankaCropper__navButton svg {
    stroke: #eee
}

.ankaCropper.dark .ankaCropper__navButton:hover {
    background: #000
}

</style>
